/**
 * @generated SignedSource<<5550dcebd82b8bb972272fb708e6aa82>>
 * @relayHash e2ca68a56c1fed790bf830b0142bc206
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c8290fc725ce4466318ac332a0b7c1207089c315272240d7732b8708d6be10f2

import type { ConcreteRequest, Query } from 'relay-runtime';
export type AgentStudioKnowledgeConfigAppQuery$variables = {
  helpCenterAri: string;
};
export type AgentStudioKnowledgeConfigAppQuery$data = {
  readonly csmAi_getAiHubByHelpCenterAri: {
    readonly agent?: {
      readonly id?: string;
    } | null | undefined;
  } | null | undefined;
};
export type AgentStudioKnowledgeConfigAppQuery = {
  response: AgentStudioKnowledgeConfigAppQuery$data;
  variables: AgentStudioKnowledgeConfigAppQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "helpCenterAri"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "helpCenterAri",
    "variableName": "helpCenterAri"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "id"
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    (v2/*: any*/)
  ],
  "type": "CsmAiAgent"
},
v4 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AgentStudioKnowledgeConfigAppQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v3/*: any*/)
                ]
              }
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgentStudioKnowledgeConfigAppQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "csmAi_getAiHubByHelpCenterAri",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "LinkedField",
                "name": "agent",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v3/*: any*/)
                ]
              },
              (v2/*: any*/)
            ],
            "type": "CsmAiHub"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "c8290fc725ce4466318ac332a0b7c1207089c315272240d7732b8708d6be10f2",
    "metadata": {},
    "name": "AgentStudioKnowledgeConfigAppQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2aeac10a93e991fb6ae9481cc9f8b054";

export default node;
